<script lang="ts" setup>
  import { useBreakpoints } from '@storefront/storefront';

  const breakpoints = useBreakpoints();

  defineProps({
    href: { type: String, required: false },
  });
</script>
<template>
  <div v-if="!breakpoints.lg" class="nav-account">
    <SfButton v-if="href" :aria-label="$t('SHOP.COMMON.ACTION.BACK')" :href="href" class="nav-account__back" rounded square transparent>
      <SfIconChevronLeft aria-hidden="true" />
    </SfButton>
    <h1 class="nav-account__title">
      <slot name="default" />
    </h1>
  </div>
</template>
<style lang="scss">
  :root {
    --sf-account-nav-background: var(--section-background);
    --sf-account-nav-border-inline: var(--section-border-inline);
    --sf-account-nav-border-block: var(--section-border-block);
    --sf-account-nav-font-size: 1.125rem;
    --sf-account-nav-font-weight: var(--font-weight-semi);
    --sf-account-nav-font-family: var(--font-family-sans);
    --sf-account-nav-line-height: 1.25;
    --sf-account-nav-icon-font-size: 1rem;
    --sf-account-nav-color: rgb(0, 0, 0);
    --sf-account-nav-margin-top: 0;
    --sf-account-nav-margin-bottom: 1rem;
    --sf-account-nav-padding-y: 0.75rem;
    --sf-account-nav-padding-x: 0;
    --sf-account-nav-box-shadow: none;
  }

  .nav-account {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;

    padding: var(--sf-account-nav-padding-y) var(--sf-account-nav-padding-x);
    background: var(--sf-account-nav-background);
    border-inline: var(--sf-account-nav-border-inline);
    border-block: var(--sf-account-nav-border-block);
    margin-top: var(--sf-account-nav-margin-top);
    margin-bottom: var(--sf-account-nav-margin-bottom);
    box-shadow: var(--sf-account-nav-box-shadow);

    &__title {
      padding: 0 2.5rem 0 2.5rem;
      text-align: center;
      font-size: var(--sf-account-nav-font-size);
      font-family: var(--sf-account-nav-font-family);
      line-height: var(--sf-account-nav-line-height);
      font-weight: var(--sf-account-nav-font-weight);
      color: var(--sf-account-nav-color);
      word-break: break-all;
      text-wrap: balance;
    }

    &__back {
      position: absolute;
      top: 50%;
      left: calc(var(--sf-account-nav-icon-font-size) / 2);
      transform: translateY(-50%);

      svg {
        font-size: var(--sf-account-nav-icon-font-size);
      }
    }
  }
</style>
